import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { NAVIGATION_SIDEBAR_WIDTH } from "app/pages/activation/constants/styles";

const { carbon, sky } = colorsPalettes;

export const SettingsContainer = styled.div`
    padding: 24px 126px 32px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 126px);
`;

export const TitleWrapper = styled.div`
    ${setFontVariant("h4")}
`;

export const SettingsWithButtonsWrapper = styled(Stack)`
    width: 100%;
    gap: 24px;
`;

export const SettingsShadowWrapper = styled.div`
    border-radius: 6px;
    box-sizing: border-box;
    padding: 8px;
    background: ${sky[100]};
`;

export const SettingsWrapper = styled(Stack)`
    border-radius: 6px;
    border-bottom: 1px solid ${carbon[50]};

    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    background-color: ${carbon[0]};
`;

export const SettingsContent = styled(Stack)`
    padding: 24px 32px 0;
    justify-content: start;
    flex: 1 1 auto;
`;

export const TabsContainer = styled(Flex)`
    align-items: center;

    position: sticky;
    top: 0;
    left: 0;
    z-index: 5;

    background-color: ${carbon[0]};

    &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${carbon[100]};
    }
`;
